<template>
  <div class="menu-main">
    <el-menu
        class="el-menu-vertical-demo"
        background-color="#f8fbff"
        text-color="#5f6f8f"
        active-text-color="#2f436d"
        :unique-opened="true"
        :default-active="activeMenuIndex"
        :default-openeds="openSubMenu"
        @select="handleMenuSelect"
    >
      <router-link to="/" class="router-link">
        <el-menu-item index="1" class="menu-logo-item">
          <i class="el-icon-s-home menu-logo-icon"></i>
          <span slot="title" class="onekids-title">ONEKIDS ADMIN</span>
        </el-menu-item>
      </router-link>
      <div>
        <el-submenu index="2" class="menu-group-staff" v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM ">
          <template #title>
            <i class="el-icon-notebook-2"/>
            <span>Quản lý nhân viên</span>
          </template>
          <router-link to="/master/admin/list" class="router-link">
            <el-menu-item
                index="2-1"
                @click="changeBreadcrumbMethod('master-admin-list')"
            >Danh sách nhân viên
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/admin/school" class="router-link">
            <el-menu-item
                index="2-2"
                @click="changeBreadcrumbMethod('master-admin-school')"
            >Phân quản lý trường
            </el-menu-item
            >
          </router-link>
<!--          <router-link to="/master/admin/update-permissions" class="router-link">-->
<!--            <el-menu-item-->
<!--                index="2-3"-->
<!--                @click="changeBreadcrumbMethod('master-admin-update-permissions')"-->
<!--            >Cập nhật quyền-->
<!--            </el-menu-item-->
<!--            >-->
<!--          </router-link>-->
<!--          <router-link to="/master/admin/school" class="router-link">-->
<!--            <el-menu-item-->
<!--                index="2-4"-->
<!--                @click="changeBreadcrumbMethod('master-admin-school')"-->
<!--            >Quản lý quyền-->
<!--            </el-menu-item-->
<!--            >-->
<!--          </router-link>-->
        </el-submenu>
        <el-submenu index="3" class="menu-group-agent"
                    v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM || getAppTypeUserLogin === appType.SYSTEM">
          <template #title>
            <i class="el-icon-notebook-2"/>
            <span>Quản lý đại lý</span>
          </template>
          <router-link to="/master/agent/list" class="router-link">
            <el-menu-item
                index="3-1"
                @click="changeBreadcrumbMethod('master-agent-list')"
            >Danh sách đại lý
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/agent/account" class="router-link">
            <el-menu-item
                index="3-2"
                @click="changeBreadcrumbMethod('master-agent-account')"
            >Tài khoản đại lý
            </el-menu-item
            >
          </router-link>
        </el-submenu>
        <el-submenu index="4" class="menu-group-school">
          <template #title>
            <i class="el-icon-reading"/>
            <span>Quản lý trường</span>
          </template>
          <router-link to="/master/school-agent/list" class="router-link">
            <el-menu-item
                index="4-1"
                @click="changeBreadcrumbMethod('master-school-agent-list')"
            >Danh sách trường
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/school-agent/account-school" class="router-link">
            <el-menu-item
                index="4-2"
                @click="changeBreadcrumbMethod('master-school-agent-account-school')"
            >Tài khoản nhà trường
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/school-agent/employee-in-school" class="router-link">
            <el-menu-item
                index="4-3"
                @click="changeBreadcrumbMethod('master-school-agent-employee-in-school')"
            >Danh sách nhân sự
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/school-agent/student-in-school" class="router-link">
            <el-menu-item
                index="4-4"
                @click="changeBreadcrumbMethod('master-school-agent-student-in-school')"
            >Danh sách học sinh
            </el-menu-item
            >
          </router-link>
        </el-submenu>
        <el-submenu index="5" class="menu-group-brand"
                    v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM || getAppTypeUserLogin === appType.SYSTEM">
          <template #title>
            <i class="el-icon-user"/>
            <span>Quản lý BrandName</span>
          </template>
          <router-link to="/brandname/brand" class="router-link">
            <el-menu-item
                index="5-1"
                @click="changeBreadcrumbMethod('brandname-brand')"
            >Cấu hình kết nối
            </el-menu-item
            >
          </router-link>
          <router-link to="/brandname/agent" class="router-link">
            <el-menu-item
                index="5-2"
                @click="changeBreadcrumbMethod('brandname-agent')"
            >Thiết lập Brand đại lý
            </el-menu-item
            >
          </router-link>
          <router-link to="/brandname/school-brand" class="router-link">
            <el-menu-item
                index="5-3"
                @click="changeBreadcrumbMethod('brandname-school-brand')"
            >Thiết lập Brand Trường
            </el-menu-item
            >
          </router-link>
        </el-submenu>
        <el-submenu index="6" class="menu-group-notify"
                    v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM || getAppTypeUserLogin === appType.SYSTEM">
          <template #title>
            <i class="el-icon-user-solid"/>
            <span>Quản lý thông báo</span>
          </template>
          <router-link to="/master/notify/news-onekids" class="router-link">
            <el-menu-item
                index="6-1"
                @click="changeBreadcrumbMethod('master-notify-news-onekids')"
            >Tin tức Onekids
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/notify/notify-onekids" class="router-link">
            <el-menu-item
                index="6-2"
                @click="changeBreadcrumbMethod('master-notify-notify-onekids')"
            >Thông báo Onekids
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/notify/history-sms" class="router-link">
            <el-menu-item
                index="6-3"
                @click="changeBreadcrumbMethod('master-notify-history-sms')"
            >Lịch sử nhắn SMS
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/notify/feedback-onekids" class="router-link">
            <el-menu-item
                index="6-4"
                @click="changeBreadcrumbMethod('master-notify-feedback-onekids')"
            >Góp ý Onekids
            </el-menu-item
            >
          </router-link>
        </el-submenu>
        <el-submenu index="7" class="menu-group-account" v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM  || getAppTypeUserLogin === appType.SYSTEM">
          <template #title>
            <i class="el-icon-s-custom"/>
            <span>Quản lý tài khoản</span>
          </template>
          <router-link to="/master/user/account" class="router-link">
            <el-menu-item
                index="7-1"
                @click="changeBreadcrumbMethod('master-user-account')"
            >Tài khoản người dùng
            </el-menu-item
            >
          </router-link>
        </el-submenu>
        <el-submenu index="8" class="menu-group-config">
          <template #title>
            <i class="el-icon-setting"/>
            <span>Cấu hình hệ thống</span>
          </template>
          <router-link to="/master/system-config/attendance-sample" class="router-link">
            <el-menu-item
                index="8-1"
                @click="changeBreadcrumbMethod('master-system-config-attendance-sample')"
            >Mẫu điểm danh, lời chúc
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/system-config/evaluate-sample" class="router-link">
            <el-menu-item
                index="8-2"
                @click="changeBreadcrumbMethod('master-system-config-evaluate-sample')"
            >Mẫu nhận xét
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/system-config/school" class="router-link">
            <el-menu-item
                index="8-3"
                @click="changeBreadcrumbMethod('master-system-config-school')"
            >Cấu hình nhà trường
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/system-config/system-setting" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="8-4"
                @click="changeBreadcrumbMethod('master-system-config-system-setting')"
            >Thiết lập hệ thống
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/system-config/web-system-title" class="router-link">
            <el-menu-item
                index="8-5"
                @click="changeBreadcrumbMethod('master-system-config-web-system-title')"
            >Thiết lập tiêu đề nội dung
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/system-config/api" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="8-6"
                @click="changeBreadcrumbMethod('master-system-config-api')"
            >
              Cập nhật quyền
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/support" class="router-link">
            <el-menu-item
                index="8-7"
                @click="changeBreadcrumbMethod('master-system-config-support')"
            >
              Thiết lập hỗ trợ
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/template" class="router-link">
            <el-menu-item
                index="8-8"
                @click="changeBreadcrumbMethod('master-system-config-template')"
            >
              Thiết lập giao diện
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/ticket" class="router-link">
            <el-menu-item
                index="8-9"
                @click="changeBreadcrumbMethod('master-system-config-ticket')"
            >
              Thiết lập phiếu bé ngoan
            </el-menu-item>
          </router-link>

          <router-link to="/master/system-config/survey-form" class="router-link">
            <el-menu-item
                index="8-10"
                @click="changeBreadcrumbMethod('master-system-config-survey-form')"
            >Thiết lập phiếu khảo sát
            </el-menu-item
            >
          </router-link>

          <router-link to="/master/system-config/orther" class="router-link">
            <el-menu-item
                index="8-11"
                @click="changeBreadcrumbMethod('master-system-config-orther')"
            >Thiết lập khác
            </el-menu-item
            >
          </router-link>
          <router-link to="/package-student/packages" class="router-link">
            <el-menu-item
                index="8-12"
                @click="changeBreadcrumbMethod('package-student-packages')"
            >Gói giới hạn học sinh
            </el-menu-item>
          </router-link>
        </el-submenu>
        <el-submenu index="9" class="menu-group-systemdata">
          <template #title>
            <i class="el-icon-s-shop"/>
            <span>Dữ liệu hệ thống</span>
          </template>
          <router-link to="/master/other/create-data-system" class="router-link">
            <el-menu-item
                index="9-1"
                @click="changeBreadcrumbMethod('master-other-create-data-system')"
            >Tạo dữ liệu chung
            </el-menu-item
            >
          </router-link>

          <router-link to="/master/other/manage-request-system" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="9-2"
                @click="changeBreadcrumbMethod('master-other-manage-request-system')"
            >Quản lý truy cập
            </el-menu-item
            >
          </router-link>
<!--          v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"-->
          <router-link to="/master/other/manage-data-system" class="router-link">
            <el-menu-item
                index="9-3"
                @click="changeBreadcrumbMethod('master-other-manage-data-system')"
            >Quản lý dữ liệu
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/other/manage-operation-history" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="9-4"
                @click="changeBreadcrumbMethod('master-other-manage-operation-history')"
            >Lịch sử thao tác
            </el-menu-item
            >
          </router-link>
          <router-link to="/master/other/auto-run-configuration" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="9-5"
                @click="changeBreadcrumbMethod('master-other-auto-run-configuration')"
            >Cấu hình chạy tự động</el-menu-item
            ></router-link>
          <router-link to="/master/other/receive-messages-system" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="9-6"
                @click="changeBreadcrumbMethod('master-other-receive-messages-system')"
            >Số điện thoại</el-menu-item
            ></router-link>
          <router-link to="/master/other/icon-system" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="9-7"
                @click="changeBreadcrumbMethod('master-other-icon-system')"
            >Icon hệ thống</el-menu-item
            ></router-link>
          <router-link to="/master/other/onekids-config" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="9-8"
                @click="changeBreadcrumbMethod('master-other-onekids-config')"
            >Thiết lập hệ thống</el-menu-item
            ></router-link>
          <router-link to="/master/other/login-config" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="9-9"
                @click="changeBreadcrumbMethod('master-other-login-config')"
            >Cấu hình trang đăng nhập</el-menu-item
            ></router-link>
        </el-submenu>
        <el-submenu index="10" class="menu-group-ai">
          <template #title>
            <i class="el-icon-s-platform"/>
            <span>Quản lý nhận diện AI</span>
          </template>
          <router-link to="/master/system-config/devices-face-recognition" class="router-link">
            <el-menu-item
                index="10-1"
                @click="changeBreadcrumbMethod('master-devices-face-recognition')"
            >
              Danh sách thiết bị
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/card-manager-recognition" class="router-link">
            <el-menu-item
                index="10-2"
                @click="changeBreadcrumbMethod('master-card-manager-recognition')"
            >
              Quản lý thẻ
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/check-info-recognition" class="router-link">
            <el-menu-item
                index="10-3"
                @click="changeBreadcrumbMethod('master-check-info-recognition')"
            >
              Kiểm tra TT AI
            </el-menu-item>
          </router-link>
        </el-submenu>
        <el-submenu index="11" class="menu-group-banking">
          <template #title>
            <i class="el-icon-money"/>
            <span>Thanh toán trực tuyến</span>
          </template>
          <router-link to="/master/system-config/bank-connection" class="router-link">
            <el-menu-item
                index="11-1"
                @click="changeBreadcrumbMethod('master-bank-connection')"
            >
              Danh sách ngân hàng
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/brand-name-connection" class="router-link">
            <el-menu-item
                index="11-2"
                @click="changeBreadcrumbMethod('master-brand-name-connection')"
            >
              Danh sách đại lý cho trường
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/linked-school-bank-account" class="router-link">
            <el-menu-item
                index="11-3"
                @click="changeBreadcrumbMethod('master-linked-school-bank-account')"
            >
              Danh sách ngân hàng liên kết
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/student-user-statistics-admin" class="router-link">
            <el-menu-item
                index="11-4"
                @click="changeBreadcrumbMethod('master-student-user-statistics-admin')"
            >
              Danh sách học sinh sử dụng
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/bank-transaction-statistics" class="router-link">
            <el-menu-item
                index="11-5"
                @click="changeBreadcrumbMethod('master-bank-transaction-statistics')"
            >
              Thống kê lịch sử giao dịch
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/transaction-volume-chart" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="11-6"
                @click="changeBreadcrumbMethod('master-transaction-volume-chart')"
            >
              Thống kê số lượng giao dịch
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/transaction-counter-admin" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="11-7"
                @click="changeBreadcrumbMethod('master-transaction-counter-admin')"
            >
              Bộ đếm giao dịch
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/merchant/online-payment" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="11-8"
                @click="changeBreadcrumbMethod('master-merchant-online-payment')"
            >
              Quản lý Merchant
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/webhook/online-payment" class="router-link">
            <el-menu-item
                v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM"
                index="11-9"
                @click="changeBreadcrumbMethod('master-webhook-online-payment')"
            >
              Quản lý Webhook
            </el-menu-item>
          </router-link>
        </el-submenu>
        <el-submenu index="12" class="menu-group-chat" v-if="getAppTypeUserLogin === appType.SUPPER_SYSTEM">
          <template #title>
            <i class="el-icon-chat-line-square"/>
            <span>Quản lý App Chat</span>
          </template>
          <router-link to="/master/system-config/emotion-chat-admin" class="router-link">
            <el-menu-item
                index="12-1"
                @click="changeBreadcrumbMethod('master-admin-manager-emotions-chat')"
            >
              Emotions tin nhắn
            </el-menu-item>
          </router-link>
          <router-link to="/master/system-config/tag-chat-admin" class="router-link">
            <el-menu-item
                index="12-2"
                @click="changeBreadcrumbMethod('master-admin-manager-tags-chat')"
            >
              Thẻ hệ thống
            </el-menu-item>
          </router-link>
        </el-submenu>

      </div>

    </el-menu>
  </div>
</template>
<script>
import {appType} from "@/constant/listCommon";
import {mapState} from "vuex";

export default {
  data() {
    return {
      appType,
      breadcrumbDataList: [
        /**
         * menu dành cho nhân viên công ty, admin
         */
        //quản lý nhân viên
        {
          key: "master-admin-list",
          value: [{url: "/master/admin/list", name: "Danh sách nhân viên"}],
        },
        {
          key: "master-admin-school",
          value: [{url: "/master/admin/school", name: "Phân quản lý trường"}],
        },
        {
          key: "master-update-permissions",
          value: [{url: "/master/admin/update-permissions", name: "Cập nhật quyền"}],
        },
        //quản lý đại lý
        {
          key: "master-agent-list",
          value: [{url: "/master/agent/list", name: "Danh sách đại lý"}],
        },
        {
          key: "master-agent-account",
          value: [{url: "/master/agent/account", name: "Tài khoản đại lý"}],
        },
        //quản lý trường
        {
          key: "master-school-agent-list",
          value: [{url: "/master/school-agent/list", name: "Danh sách trường"}],
        },
        {
          key: "master-school-agent-account-school",
          value: [
            {
              url: "/master/school-agent/account-school",
              name: "Tài khoản nhà trường",
            },
          ],
        },
        {
          key: "master-school-agent-employee-in-school",
          value: [
            {
              url: "/master/school-agent/employee-in-school",
              name: "Danh sách nhân sự",
            },
          ],
        },
        {
          key: "master-school-agent-student-in-school",
          value: [
            {
              url: "/master/school-agent/student-in-school",
              name: "Danh sách học sinh",
            },
          ],
        },
        //quản lý brand name
        {
          key: "brandname-brand",
          value: [{url: "/brandname/brand", name: "Cấu hình kết nối"}],
        },
        {
          key: "brandname-agent",
          value: [{url: "/brandname/agent", name: "Thiết lập Brand đại lý"}],
        },
        {
          key: "brandname-school-brand",
          value: [{url: "/brandname/school-brand", name: "Thiết lập Brand Trường"}],
        },
        //quản lý thông báo
        {
          key: "master-notify-news-onekids",
          value: [{url: "/master/notify/news-onekids", name: "Tin tức Onekids"}],
        },
        {
          key: "master-notify-notify-onekids",
          value: [{url: "/master/notify/notify-onekids", name: "Thông báo Onekids"}],
        },
        {
          key: "master-notify-history-sms",
          value: [{url: "/master/notify/history-sms", name: "Lịch sử nhắn SMS"}],
        },
        {
          key: "master-notify-feedback-onekids",
          value: [{url: "/master/notify/feedback-onekids", name: "Góp ý Onekids"}],
        },
        //thông báo nội bộ
        {
          key: "master-notification-notify",
          value: [{url: "/master/notification/notify", name: "Cấu hình gửi tin"}],
        },
        {
          key: "master_internal_notification_plus",
          value: [
            {
              url: "/master/notification/internal-notification",
              name: "Thông báo nội bộ",
            },
          ],
        },
        //quản lý tài khoản
        {
          key: "master-user-account",
          value: [{url: "/master/user/account", name: "Tài khoản người dùng"}],
        },
        //cấu hình hệ thống
        {
          key: "master-system-config-attendance-sample",
          value: [
            {
              url: "/master/system-config/attendance-sample",
              name: "Mẫu điểm danh, lời chúc",
            },
          ],
        },
        {
          key: "master-system-config-evaluate-sample",
          value: [
            {
              url: "/master/system-config/evaluate-sample",
              name: "Mẫu nhận xét",
            },
          ],
        },
        {
          key: "master-system-config-school",
          value: [
            {
              url: "/master/system-config/school",
              name: "Cấu hình nhà trường",
            },
          ],
        },
        {
          key: "master-system-config-system-setting",
          value: [
            {
              url: "/master/system-config/system-setting",
              name: "Thiết lập hệ thống",
            },
          ],
        },
        {
          key: "master-system-config-web-system-title",
          value: [
            {
              url: "/master/system-config/web-system-title",
              name: "Thiết lập tiêu đề, nội dung",
            },
          ],
        },
        {
          key: "master-system-config-api",
          value: [{url: "/master/system-config/api", name: "Cập nhật quyền"}],
        },
        {
          key: "master-system-config-support",
          value: [{url: "/master/system-config/support", name: "Thiết lập hỗ trợ"}],
        },
        {
          key: "master-system-config-orther",
          value: [{url: "/master/system-config/other", name: "Thiết lập khác"}],
        },
        {
          key: "package-student-packages",
          value: [{url: "/package-student/packages", name: "Gói giới hạn học sinh"}],
        },
        {
          key: "master-system-config-ticket",
          value: [{url: "/master/system-config/ticket", name: "Thiết lập phiếu bé ngoan"}],
        },
        {
          key: "master-system-config-template",
          value: [{url: "/master/system-config/template", name: "Thiết lập giao diện"}],
        },
        {
          key: "master-system-config-survey-form",
          value: [{url: "/master/system-config/survey-form", name: "Thiết lập mẫu phiếu"}],
        },
        //tạo dữ liệu hệ thống
        {
          key: "master-other-create-data-system",
          value: [{url: "/master/other/create-data-system", name: "Tạo dữ liệu chung"}],
        },
        // Xem lượng truy cập BE
        {
          key: "master-other-manage-request-system",
          value: [{url: "/master/other/manage-request-system", name: "Lượng truy cập hệ thống "}],
        },
        // Xóa dữ liệu lớn
        {
          key: "master-other-manage-data-system",
          value: [{url: "/master/other/manage-data-system", name: "Quản lý dữ liệu"}],
        },
        //Lịch sử thao tác
        {
          key: "master-other-manage-operation-history",
          value: [{url: "/master/other/manage-operation-history", name: "Lịch sử thao tác"}],
        },

        //Danh sách thiết bị
        {
          key: "master-devices-face-recognition",
          value: [
            {
              url: "/master/system-config/devices-face-recognition",
              name: "Danh sách thiết bị"
            }
          ]
        },
        {
          key: "master-card-manager-recognition",
          value: [
            {
              url: "/master/system-config/card-manager-recognition",
              name: "Quản lý thẻ"
            }
          ]
        },
        {
          key: "master-check-info-recognition",
          value: [
            {
              url: "/master/system-config/check-info-recognition",
              name: "Kiểm tra TT AI"
            }
          ]
        },
        {
          key: "master-other-auto-run-configuration",
          value: [{url: "/master/other/auto-run-configuration", name: "Cấu hình chạy tự động"}],
        },
        {
          key: "master-other-receive-messages-system",
          value: [{url: "/master/other/receive-messages-system", name: "Số điện thoại nhận tin nhắn hệ thống"}],
        },
        {
          key: "master-other-icon-system",
          value: [{url: "/master/other/icon-system", name: "Icon hệ thống"}],
        },
        {
          key: "master-other-onekids-config",
          value: [{url: "/master/other/onekids-config", name: "Thiết lập hệ thống"}],
        },
        {
          key: "master-other-login-config",
          value: [{url: "/master/other/login-config", name: "Cấu hình trang đăng nhập"}],
        },
          //SePay
        {
          key: "master-bank-connection",
          value: [{url: "/master/system-config/bank-connection", name: "Danh sách ngân hàng"}],
        },
        {
          key: "master-brand-name-connection",
          value: [{url: "/master/system-config/brand-name-connection", name: "Danh sách đại lý cho trường"}],
        },
        {
          key: "master-linked-school-bank-account",
          value: [{url: "/master/system-config/linked-school-bank-account", name: "Danh sách ngân hàng liên kết"}],
        },
        {
          key: "master-student-user-statistics-admin",
          value: [{url: "/master/system-config/student-user-statistics-admin", name: "Danh sách học sinh sử dụng"}],
        },
        {
          key: "master-bank-transaction-statistics",
          value: [{url: "/master/system-config/bank-transaction-statistics", name: "Thống kê lịch sử giao dịch"}],
        },
        {
          key: "master-transaction-volume-chart",
          value: [{url: "/master/system-config/transaction-volume-chart", name: "Thống kê số lượng giao dịch"}],
        },
        {
          key: "master-transaction-counter-admin",
          value: [{url: "/master/system-config/transaction-counter-admin", name: "Bộ đếm giao dịch"}],
        },
        {
          key: "master-merchant-online-payment",
          value: [{url: "/master/system-config/merchant/online-payment", name: "Quản lý Merchant"}],
        },
        {
          key: "master-webhook-online-payment",
          value: [{url: "/master/system-config/webhook/online-payment", name: "Quản lý Webhook"}],
        },
        {
          key: "master-manager-admin-account-manager",
          value: [{url: "/master/manager-admin/account-manager", name: "Tài khoản admin"}],
        },

        {
          key: "master-admin-manager-emotions-chat",
          value: [{
            url: "/master/system-config/emotion-chat-admin",
            name: "Quản lý emotions Chat"
          }]
        },
        {
          key: "master-admin-manager-tags-chat",
          value: [{
            url: "/master/system-config/tag-chat-admin",
            name: "Quản lý thẻ Chat"
          }]
        },

      ]
    }
  },

  computed: {
    // getIsOpenCloseMenu() {
    //   return this.$store.getters["layout/getIsOpenClose"];
    // },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    ...mapState("notificationNavbarStore", ["activeMenuIndex", "openSubMenu"]),
  },
  methods: {
    handleMenuSelect(index, indexPath) {
      const sidebar = document.querySelector('.sidebar-wrapper');
      const savedScrollTop = sidebar ? sidebar.scrollTop : 0;

      // Lưu toàn bộ các submenu cha (bỏ phần tử cuối là menu-item được click)
      const openSubMenuList = (indexPath || []).slice(0, -1);
      this.$store.dispatch("notificationNavbarStore/handleActiveSubmenu", {
        menuIndex: openSubMenuList,
        menuItemIndex: index,
      });

      this.$nextTick(() => {
        if (sidebar) sidebar.scrollTop = savedScrollTop;
      });
    },
    changeBreadcrumbMethod(val) {
      let selectUrl = this.breadcrumbDataList.filter((x) => x.key === val);
      if (selectUrl.length > 0) {
        let dataList = selectUrl[0].value;
        sessionStorage.setItem("breadcrumbList", JSON.stringify(dataList));
        this.$store.dispatch("layout/setBreadcrumbActions", dataList);
      }
    },

  },

}
</script>
<style lang="scss" scoped>
.menu-main {
  min-height: 950px;
  padding: 10px 12px 16px;
  background:
      radial-gradient(circle at top left, rgba(157, 197, 255, 0.28), transparent 28%),
      radial-gradient(circle at 100% 12%, rgba(255, 196, 214, 0.22), transparent 24%),
      linear-gradient(180deg, #f9fbff 0%, #f3f7ff 52%, #eef4fb 100%);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 260px;
  min-height: 700px;
  font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  border-right: none !important;
  border-radius: 18px;
  overflow: hidden;
}

.router-link {
  text-decoration: none;
}

.el-menu-item.menu-logo-item {
  background: linear-gradient(135deg, #eef2ff 0%, #e3efff 52%, #f5e8ff 100%) !important;
  border-bottom: 1px solid #d7e3ff !important;
  height: 60px !important;
  line-height: normal !important;
  margin-bottom: 6px;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  &:hover {
    background: linear-gradient(135deg, #e8f0ff 0%, #dbebff 50%, #f0e4ff 100%) !important;
    border-left-color: transparent !important;
  }
}

.menu-logo-icon {
  color: #5b7fd8 !important;
  font-size: 20px !important;
  background: linear-gradient(135deg, rgba(91, 127, 216, 0.16), rgba(173, 114, 255, 0.14));
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

/deep/ .el-menu--collapse .menu-logo-icon {
  margin-right: 0 !important;
}

.onekids-title {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 1.2px;
  color: #2f436d !important;
  text-transform: uppercase;
}

.el-menu-item {
  background-color: transparent !important;
  height: 40px !important;
  line-height: 40px !important;
  font-size: 14px !important;
  color: #6c7b98 !important;
  border-left: 3px solid transparent !important;
  padding-left: 46px !important;
  border-radius: 10px !important;
  margin: 2px 8px !important;
  transition: all 0.22s ease;

  &:hover {
    background: linear-gradient(90deg, var(--menu-item-hover-start, #f2f7ff) 0%, var(--menu-item-hover-end, #eaf1ff) 100%) !important;
    color: #324b78 !important;
    border-left-color: var(--menu-accent, #7aa8ff) !important;
  }

  &.is-active {
    background: linear-gradient(90deg, var(--menu-active-start, #dfeaff) 0%, var(--menu-active-end, #d4e2ff) 100%) !important;
    color: #29456f !important;
    border-left: 3px solid var(--menu-accent-strong, #5d83dd) !important;
    font-weight: 600;
    box-shadow: inset 0 0 0 1px var(--menu-accent-border, rgba(93, 131, 221, 0.12));
  }
}

/deep/ .el-submenu__title {
  height: 48px !important;
  line-height: 48px !important;
  font-size: 14px !important;
  font-weight: 600;
  color: #5f6f8f !important;
  border-left: 3px solid transparent;
  border-radius: 12px;
  margin: 4px 8px;
  transition: all 0.25s ease;

  i {
    color: var(--menu-accent, #7e91b2) !important;
    font-size: 15px;
    margin-right: 8px;
    transition: color 0.2s ease;
  }

  > i:first-child {
    width: 28px;
    height: 28px;
    border-radius: 10px;
    margin-right: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--menu-accent-soft, rgba(93, 131, 221, 0.12));
    box-shadow: inset 0 0 0 1px var(--menu-accent-border, rgba(93, 131, 221, 0.14));
  }

  &:hover {
    background: linear-gradient(90deg, var(--menu-hover-start, #eff5ff) 0%, var(--menu-hover-end, #e8f0ff) 100%) !important;
    color: #324b78 !important;
    border-left-color: var(--menu-accent, #7aa8ff) !important;

    i {
      color: var(--menu-accent-strong, #5d83dd) !important;
    }
  }
}

/deep/ .el-submenu.is-opened > .el-submenu__title {
  background: linear-gradient(90deg, var(--menu-open-start, #edf4ff) 0%, var(--menu-open-end, #e5efff) 100%) !important;
  color: #2f436d !important;
  border-left: 3px solid var(--menu-accent, #6d96f5) !important;

  i {
    color: var(--menu-accent-strong, #5d83dd) !important;
  }
}

/deep/ .el-submenu__icon-arrow {
  color: #8b9aba !important;
  font-size: 11px;
  right: 12px;
}

/deep/ .el-message-box {
  display: inline-block;
  vertical-align: top !important;
  width: 420px;
  padding-bottom: 10px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

/deep/ .el-message-box__wrapper::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: top !important;
}

.el-menu {
  margin-bottom: 20px;
  border: 1px solid #e2eaf7 !important;
  box-shadow: 0 10px 30px rgba(65, 84, 118, 0.08);
  background: rgba(255, 255, 255, 0.82) !important;
  backdrop-filter: blur(6px);
}

.menu-group-staff,
.menu-group-account {
  --menu-accent: #a56df5;
  --menu-accent-strong: #8a50e2;
  --menu-accent-soft: rgba(165, 109, 245, 0.15);
  --menu-accent-border: rgba(165, 109, 245, 0.18);
  --menu-hover-start: #f7f0ff;
  --menu-hover-end: #f1e8ff;
  --menu-open-start: #f2e9ff;
  --menu-open-end: #ebddff;
  --menu-item-hover-start: #f7f0ff;
  --menu-item-hover-end: #f0e6ff;
  --menu-active-start: #ece0ff;
  --menu-active-end: #e3d3ff;
}

.menu-group-agent,
.menu-group-notify {
  --menu-accent: #f36b8a;
  --menu-accent-strong: #df4f71;
  --menu-accent-soft: rgba(243, 107, 138, 0.14);
  --menu-accent-border: rgba(243, 107, 138, 0.18);
  --menu-hover-start: #fff1f5;
  --menu-hover-end: #ffe7ee;
  --menu-open-start: #ffeaf0;
  --menu-open-end: #ffe0e9;
  --menu-item-hover-start: #fff2f6;
  --menu-item-hover-end: #ffe7ee;
  --menu-active-start: #ffdfe8;
  --menu-active-end: #ffd2de;
}

.menu-group-school,
.menu-group-systemdata {
  --menu-accent: #ff9f43;
  --menu-accent-strong: #f08a20;
  --menu-accent-soft: rgba(255, 159, 67, 0.16);
  --menu-accent-border: rgba(255, 159, 67, 0.2);
  --menu-hover-start: #fff7ee;
  --menu-hover-end: #ffefdf;
  --menu-open-start: #fff2e4;
  --menu-open-end: #ffe8d0;
  --menu-item-hover-start: #fff7ee;
  --menu-item-hover-end: #ffefdf;
  --menu-active-start: #ffeccf;
  --menu-active-end: #ffe2bb;
}

.menu-group-brand,
.menu-group-ai,
.menu-group-chat {
  --menu-accent: #8b7cf6;
  --menu-accent-strong: #7161e8;
  --menu-accent-soft: rgba(139, 124, 246, 0.15);
  --menu-accent-border: rgba(139, 124, 246, 0.18);
  --menu-hover-start: #f4f2ff;
  --menu-hover-end: #ebe8ff;
  --menu-open-start: #efebff;
  --menu-open-end: #e6e0ff;
  --menu-item-hover-start: #f4f2ff;
  --menu-item-hover-end: #ece8ff;
  --menu-active-start: #e5deff;
  --menu-active-end: #dbd2ff;
}

.menu-group-config,
.menu-group-banking {
  --menu-accent: #2fbf8f;
  --menu-accent-strong: #1fa67a;
  --menu-accent-soft: rgba(47, 191, 143, 0.16);
  --menu-accent-border: rgba(47, 191, 143, 0.18);
  --menu-hover-start: #eefcf7;
  --menu-hover-end: #e4f9f0;
  --menu-open-start: #e6f8f0;
  --menu-open-end: #dcf4ea;
  --menu-item-hover-start: #eefcf7;
  --menu-item-hover-end: #e3f8ef;
  --menu-active-start: #d7f4ea;
  --menu-active-end: #caf0e3;
}

@media (max-width: 1200px) {
  .menu-main {
    padding: 8px;
  }
}
</style>
